import router from '../router'
/**
 * 统一的跳转方法
 */
export default {
	/**
     * 取缓存
     */
	getCache(key) {
		var data = JSON.parse(localStorage.getItem(key));
		var now = new Date();
		if (data && data.count > 0 && data.time > now.getTime()) {
			return data;
		} else {
			return false;
		}
	},
	/**
	 * 设置缓存
	 */
	setCache(key, data) {
		//缓存时间1天
		var ExpireTime = 86400000;
		var expDate = new Date();
		data.time = expDate.getTime() + ExpireTime;
		localStorage.setItem(key, JSON.stringify(data));
	},
	//跳转登录页面
	goLogin() {
		router.push("/login")
	},
	// 跳转注册页
	goReg() {
		router.push("/reg")
	},
	//跳转至搜索
	goSearch(id) {
		console.info("goSearch ",id);
		router.push({ path: '/search', query: { cate_id: id } })
	},
	//推荐位更多
	goMore(id, title) {
		router.push({ path: '/more', query: { tid: id, title: title } })
	},
	//跳转至我的书架
	goMybook() {
		//需要登录的，先保存当前状态，等登录后跳转
		let data = { path: "mybook" };
		localStorage.setItem("loginBack", JSON.stringify(data));
		router.push(data)
	},
	//    跳转至个人中心
	goPersonal() {
		router.push("/personal")
	},
	downloadApp() {
		router.push("/loadpage")
	},
	//    跳转至详情
	goDetail(id) {
		//收藏或评论时需要登录的，先保存当前状态，等登录后跳转
		let data = { path: '/bookdetail', query: { id: id } };
		localStorage.setItem("loginBack", JSON.stringify(data));
		router.push(data)
	},
	//返回首页
	backIndex() {
		//由于首页有充值回跳的检查，所以手动到首页时，要清理掉回跳的设置
		localStorage.removeItem("loginBack");
		router.push("/")
	},
	goPay(title, coin, id) {
		let data ={ path: "/pay", query: { id: id, title: title, coin: coin } };
		router.push(data)
	},
	//金币不够提示，支付后跳回章节
	goReadPay(title, coin, id,itemId) {
		let backData  = { path: "/read", query: { id: id } }
		localStorage.setItem("loginBack", JSON.stringify(backData));

		let data ={ path: "/readpay", query: { id: id, title: title, coin: coin,itemId:itemId } };
		router.push(data)
	},
	goPaypal(id) {
		router.push({ path: "/paypal", query: { id: id } })
	},
	goMyCard(id,region,title,coin){
		router.push({ path: "/card", query: { id: id,region:region,title:title,coin:coin } })
	},
	goMalai(id) {
		router.push({ path: "/malaysia", query: { id: id } })
	},
	goPFT(id) {
		router.push({ path: "/little", query: { id: id } })
	},
	/**
	 * 检查登录
	 */
	checkLogin() {
		var uid = parseInt(localStorage.getItem('loginUserID'));
		console.info("login uid:", uid);
		return uid > 0;
	},
	//反馈
	feedback() {
		router.push("/feedback")
	},
	//修改密码
	changepwd() {
		router.push("/changepwd")
	},
	//跳转目录
	goItemList(id) {
		router.push({ path: '/catalog', query: { id: id } });
	},
	goCmt(id) {
		router.push({ path: '/cmtlist', query: { id: id } });
	},
	//阅读章节
	goRead(id) {
		//可能要充值的，先保存当前状态，待充值后回跳
		var data = { path: "/read", query: { id: id } }
		localStorage.setItem("loginBack", JSON.stringify(data));
		router.push({ path: "/read", query: { id: id } });
	},
	/**
	 * 充值後回跳
	 */
	goAfterRecharge(){
		var url = JSON.parse(localStorage.getItem("loginBack"));
          if(url){
            localStorage.removeItem("loginBack");
            router.push(url);
          }else{
            localStorage.removeItem("loginBack");
			router.push("/")
          }
	},
	//客户端类型
	getMobileBrowser() {
		if (/android/i.test(navigator.userAgent)) return 'Android';
		if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) return 'IOS';
		if (/MicroMessenger/i.test(navigator.userAgent)) return 'weixin';
		return false;
	}

}


// WEBPACK FOOTER //
// ./src/go/go.js